import React, { useState, useEffect } from "react";
import { RiArrowDropDownLine } from "react-icons/ri";
import { RiArrowDropUpLine } from "react-icons/ri";
import axios from "axios";
import { apiBaseUrl } from "../../config";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { useUser } from "../../context/userContext";
import { getDomainInfo } from "../../utils/utils";

const Description = ({ productDescription }) => {
  const { userId } = useParams();
  const { uid } = getDomainInfo(userId);
  const { userData, fetchUserData } = useUser();
  useEffect(() => {
    if (uid) {
      fetchUserData(uid);
    } else {
      console.error("UID is undefined, skipping fetchUserData.");
    }
  }, [uid]);
  const storeid = useSelector((state) => state.fetchUser?.user?.id);
  const userid=userData?.id;
  const [openIndex, setOpenIndex] = useState(null);
  const [policies, setPolicies] = useState([]);

  const toggleAccordion = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  useEffect(() => {
    const fetchPolicies = async () => {
      try {
        const response = await axios.get(`${apiBaseUrl}policy/get-all-policies/${storeid??userid}`);
        if (response.data && response.data.policies) {
          setPolicies(response.data.policies);
        }
      } catch (error) {
        console.error("Error fetching policies:", error);
      }
    };

    fetchPolicies();
  }, [storeid]);

  // Dynamically update sections based on policies
  const sections = [
    {
      title: "Description",
      content: productDescription,
    },
    {
      title: "Shipping Policy",
      content: policies.find((policy) => policy.policy_header === "Shipping Policy")?.policy_description || "<p>No Shipping Policy available.</p>",
    },
    {
      title: "Return & Replacement Policy",
      content: policies.find((policy) => policy.policy_header === "Return & Replacement Policy")?.policy_description || "<p>No Return & Exchange Policy available.</p>",
    },
  ];

  return (
    <div className="description-accordion">
      {sections.map((section, index) => (
        <div key={index} className="description-accordion-item">
          <div className="description-accordion-header" onClick={() => toggleAccordion(index)}>
            <b className={"fontclass"}>{section.title}</b>
            <span className="arrow fontclass">
              {openIndex === index ? <RiArrowDropUpLine /> : <RiArrowDropDownLine />}
            </span>
          </div>
          {openIndex === index && (
            <div
              className="description-accordion-content fontclass"
              dangerouslySetInnerHTML={{ __html: section.content }}
            ></div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Description;